/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-16 20:29:45
 * @FilePath: \hippo-web-admin\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 主入口js */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import permission from './utils/permission';
import '@/assets/scss/font.scss';
import '@/assets/scss/global.scss';
import EleAdmin from 'ele-admin';
import en from 'ele-admin/packages/lang/en';
import DialogDirective from 'ele-admin/packages/utils/dialog-directive';
import VueClipboard from 'vue-clipboard2';
import {
  parseUnit,
  getUtcTime,
  getUtcFTime,
  formatNowUtc,
  getTimeZ,
  getTimeZForAr,
  date2TimeZone,
  toUtcTime,
  adjustShowUnitValue,
  getFormattedValue
} from '@/utils/utils';
import 'amfe-flexible';
import SlideVerify from 'vue-monoplasty-slide-verify';
import versionCheckPlugin from './utils/versionCheckPlugin';

const theme = process.env.VUE_APP_THEME || 'furCarer';

Vue.config.productionTip = false;
Vue.prototype.getUtcTime = getUtcTime;
Vue.prototype.getUtcFTime = getUtcFTime;
Vue.prototype.formatNowUtc = formatNowUtc;
Vue.prototype.getTimeZ = getTimeZ;
Vue.prototype.getTimeZForAr = getTimeZForAr;
Vue.prototype.toUtcTime = toUtcTime;
Vue.prototype.date2TimeZone = date2TimeZone;
Vue.prototype.adjustShowUnitValue = adjustShowUnitValue;
Vue.prototype.getFormattedValue = getFormattedValue;

//引入多语言注册文件
import i18n from '@/lang/index';
import { mapGetters } from 'vuex';

Vue.mixin({
  computed: {
    ...mapGetters(['lang']) // 全局混入 lang
  }
});

Vue.use(EleAdmin, {
  locale: en,
  request: {
    pageName: 'page',
    limitName: 'rows'
  },
  response: {
    dataName: 'rows',
    countName: 'total'
  }
});

Vue.use(versionCheckPlugin);
Vue.use(permission);
Vue.use(DialogDirective);
Vue.use(VueClipboard);
Vue.use(SlideVerify);

Vue.filter('parseUnit', (value, unit = 'mmol/L') => {
  return parseUnit(value, unit);
});

import(`./assets/scss/${theme}/theme.scss`).then(() => {
  new Vue({
    router,
    store,
    i18n, //引入i18n
    beforeCreate() {
      Vue.prototype.$bus = this;
    },
    render: (h) => h(App)
  }).$mount('#app');
});

// new Vue({
//   router,
//   store,
//   i18n,//引入i18n
//   beforeCreate(){
//     Vue.prototype.$bus = this;
//   },
//   render: (h) => h(App)
// }).$mount('#app');
